module.exports = "/_next/static/images/logo-holders-only-5c1325fb4316134db99dd354a6df0458.png";